import API from './api';

const grupos = {
  obtenerLista: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/grupos/lista',
      params: params,
      interceptor: conInterceptor
    });
  },

  getGrupo: function (codigoGrupo, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: `/grupos/${codigoGrupo}`,
      interceptor: conInterceptor
    });
  },

  solicitarAdministracion: function (params, conInterceptor = true) {
    return API.axios({
      method: 'post',
      url: '/sucursales/solicitar-administracion',
      data: params,
      interceptor: conInterceptor
    });
  },

  estadoSolicitudesAdministracion: function (params, conInterceptor = true) {
    return API.axios({
      method: 'get',
      url: '/sucursales/estado-solicitudes',
      params,
      interceptor: conInterceptor
    });
  },

  reenviarSolicitudesAdministracion: function (data, conInterceptor = true) {
    return API.axios({
      method: 'post',
      url: '/sucursales/reenviar-solicitud-administracion',
      data: data,
      interceptor: conInterceptor
    });
  }
};

export default grupos;
